// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"06f73a94","215":"cc22dc5e","219":"f5a69a30","255":"8d3d1bdc"}[chunkId] + ".chunk.js";
};